import _createForOfIteratorHelper from "/var/www/commonsku/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import { combine } from '@datadog/browser-core';
export var DISCARDED = 'DISCARDED';
export function createHooks() {
  var callbacks = {};
  return {
    register: function register(hookName, callback) {
      if (!callbacks[hookName]) {
        callbacks[hookName] = [];
      }
      callbacks[hookName].push(callback);
      return {
        unregister: function unregister() {
          callbacks[hookName] = callbacks[hookName].filter(function (cb) {
            return cb !== callback;
          });
        }
      };
    },
    triggerHook: function triggerHook(hookName, param) {
      var hookCallbacks = callbacks[hookName] || [];
      var results = [];
      var _iterator = _createForOfIteratorHelper(hookCallbacks),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var callback = _step.value;
          var result = callback(param);
          if (result === DISCARDED) {
            return result;
          }
          results.push(result);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return combine.apply(void 0, results);
    }
  };
}